// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionCTA_comp__H58sK"};